import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

//TODO: Optimise for SEO

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
